export const partners = [
  {
    alt: 'Netcomm business partner',
    src: 'netcomm.png',
    dataQa: 'guaranteesNetcommElm',
  },
];
